import { FaWhatsapp } from "react-icons/fa";
import styles from "./WhatsAppButton.module.css";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5517991254844"
      target="_blank"
      rel="noreferrer"
      className={styles.button}
    >
      <FaWhatsapp size={28} />
    </a>
  );
}